import { useCallback } from "react";
import {
  useDisableDistributorType,
  useEnableDistributorType,
} from "../mutations/useStatusDistributorTypeToggle.mutation";

export const useDistributorTypeStatusToggle = () => {
  const disableMutation = useDisableDistributorType();
  const enableMutation = useEnableDistributorType();

  const handleEnable = useCallback(
    (id: string) => enableMutation.mutate(id),
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => disableMutation.mutate(id),
    [disableMutation],
  );

  return {
    handleEnable,
    isEnabling: enableMutation.isPending,
    handleDisable,
    isDisabling: disableMutation.isPending,
  };
};
